/**
 * Disclosure behaviour for menu items that have children, in both presentations of the
 * main menu (see sections/lp-header.liquid).
 *
 *   data-lp-disclosure="panel"      desktop dropdown. CSS shows the panel on hover (pointer
 *                                   devices) or when the button reports aria-expanded="true";
 *                                   this file only manages that attribute. One open at a time,
 *                                   closed by Escape, by an outside click, or when focus leaves.
 *   data-lp-disclosure="accordion"  drawer section. Toggles the `hidden` attribute on the
 *                                   controlled list, so collapsed links drop out of the drawer's
 *                                   focus order (lp-nav-drawer.js recomputes that on every Tab).
 *
 * Delegated from document, so it needs no per-element setup and survives section re-renders
 * in the theme editor.
 */
(() => {
  if (window.lpNavMenu) return;
  window.lpNavMenu = true;

  const PANEL = '[data-lp-disclosure="panel"]';

  const panelFor = (button) => document.getElementById(button.getAttribute('aria-controls'));

  function setExpanded(button, expanded) {
    button.setAttribute('aria-expanded', String(expanded));
    if (button.dataset.lpDisclosure === 'accordion') {
      const panel = panelFor(button);
      if (panel) panel.hidden = !expanded;
    }
  }

  function closeAllPanels(except) {
    document.querySelectorAll(`${PANEL}[aria-expanded="true"]`).forEach((button) => {
      if (button !== except) setExpanded(button, false);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lp-disclosure]');
    if (button) {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      if (button.matches(PANEL)) closeAllPanels(button);
      setExpanded(button, expanded);
      return;
    }
    if (!event.target.closest('.lp-header__nav-item--parent')) closeAllPanels();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const item = document.activeElement?.closest('.lp-header__nav-item--parent');
    const button = item?.querySelector(PANEL);
    if (button?.getAttribute('aria-expanded') === 'true') {
      setExpanded(button, false);
      button.focus();
    }
  });

  document.addEventListener('focusout', (event) => {
    const item = event.target.closest?.('.lp-header__nav-item--parent');
    if (item && !item.contains(event.relatedTarget)) {
      const button = item.querySelector(PANEL);
      if (button) setExpanded(button, false);
    }
  });

  // A panel opened by click stays open until dismissed; leaving it with the pointer counts.
  document.addEventListener('mouseout', (event) => {
    const item = event.target.closest?.('.lp-header__nav-item--parent');
    if (item && !item.contains(event.relatedTarget)) {
      const button = item.querySelector(PANEL);
      if (button && !item.contains(document.activeElement)) setExpanded(button, false);
    }
  });
})();
